<template>
  <div class="div_one">
    <el-container>
      <el-header>
        <el-row
          type="flex"
          class="row-bg"
          justify="center"
          style="background-color: #364150"
        >
          <div
            class="agent_screen"
            style="
              color: rgb(191, 203, 217);
              font-weight: bold;
              font-size: large;
              line-height: 60px;
              font-size: 13px;
            "
          >
            <el-cascader
              ref="cascader"
              size=""
              :placeholder="placeholder"
              filterable
              :options="operatorsTree"
              :show-all-levels="false"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              @change="handChangeOperator"
              v-model="operatorIds"
              clearable
            >
            </el-cascader>
          </div>
        </el-row>
      </el-header>
      <el-main>
        <el-row :gutter="14">
          <el-col :span="24">
            <el-row :gutter="14">
              <el-col :xs="24" :sm="12" :md="12" :lg="6">
                <div class="top_gtitle_box">
                  <div class="top_box">
                    <el-radio-group
                      v-model="tabAnnual"
                      style="margin-bottom: 10px"
                      size="mini"
                    >
                      <el-radio-button label="income">充电收入</el-radio-button>
                      <el-radio-button label="electric">充电量</el-radio-button>
                    </el-radio-group>
                    <div class="top_title">
                      <div class="tab_icon">
                        <div v-if="tabRange">
                          {{
                            tabAnnual == "income"
                              ? "全年充电收入(元)"
                              : "当年充电量(kW·h)"
                          }}
                        </div>
                        <div v-else>
                          {{ currentMonth
                          }}{{
                            tabAnnual == "income"
                              ? "当月充电收入(元)"
                              : "当月充电量(kW·h)"
                          }}
                        </div>
                        <!-- <div class="tooltipClick" @click="tabRange = !tabRange">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="tabRange ? '月' : '年'"
                            placement="top-start"
                          >
                            <i class="el-icon-sort"></i>
                          </el-tooltip>
                        </div> -->
                      </div>
                      <div class="income" v-if="tabRange" style="font-size:34px;">
                        {{
                          tabAnnual == "income"
                            ? orderPart.currentYearData.totalFee
                            : orderPart.currentYearData.totalElectricity
                        }}
                      </div>
                      <div class="income" v-else  style="font-size:34px;">
                        {{
                          tabAnnual == "income"
                            ? orderPart.currentMonthData.totalFee
                            : orderPart.currentMonthData.totalElectricity
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="average_box">
                    <div style="opacity: 0;">
                      {{
                        tabAnnual == "income"
                          ? "日均收入(元):"
                          : "日均充电量(kW·h):"
                      }}100
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6"
                ><div class="top_gtitle_box">
                  <div class="top_box">
                    <div class="top_title">
                      当天充电收入(元)
                      <div class="income">
                        {{ orderPart.currentDayData.totalFee }}
                      </div>
                    </div>
                    <div id="income"></div>
                  </div>
                  <div class="average_box">
                    <div>
                      <!-- {{ currentMonth }}月  -->
                      最近10天日均收入(元): {{ average.income }}
                    </div>
                  </div>
                </div></el-col
              >
              <el-col :xs="24" :sm="12" :md="12" :lg="6"
                ><div class="top_gtitle_box">
                  <div class="top_box">
                    <div class="top_title">
                      当天充电量(kW·h)
                      <div class="electric">
                        {{ orderPart.currentDayData.totalElectricity }}
                      </div>
                    </div>
                    <div id="electric"></div>
                  </div>
                  <div class="average_box">
                    <div>
                      <!-- {{ currentMonth }}月  -->
                      最近10天日均充电量(kW·h):
                      {{ average.electric }}
                    </div>
                  </div>
                </div></el-col
              >
              <el-col :xs="24" :sm="12" :md="12" :lg="6"
                ><div class="top_gtitle_box">
                  <div class="top_box">
                    <div class="top_title gun_info_box">
                      <div>
                        充电枪在线率({{ gunRealTimeStatistics.onlineGunNum }}个)
                        <div class="income">
                          {{ gunRealTimeStatistics.onlineRate }}%
                        </div>
                      </div>
                      <div>
                        <div class="income fault">
                          <div>
                            <i class="el-icon-warning"></i>
                          </div>
                          <div>
                            统计:<span
                              style="color: #333333; font-size: 20px"
                              >{{ operatorAlarmRecord.alarmType4 }}</span
                            >
                            <div
                              @click="tapPage('/operatingCenter/alaramMonitor')"
                            >
                              告警信息<i class="el-icon-arrow-right"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding-top: 50px">
                      <el-progress
                        stroke-linecap="square"
                        :show-text="false"
                        :stroke-width="10"
                        :percentage="gunRealTimeStatistics.onlineRate"
                        color="rgba(0, 150, 136)"
                      ></el-progress>
                    </div>
                  </div>
                  <div class="average_box">
                    <div>充电时长(当天):{{ orderPart.chargeLength }}</div>
                    <div>利用率:{{ orderPart.usedRate }}%</div>
                  </div>
                </div></el-col
              >
            </el-row>
          </el-col>
          <el-col :span="24">
            <div class="table_box">
              <el-row :gutter="14">
                <el-col :md="24" :lg="16" :xl="16">
                  <div class="div_two div_margin" style="">
                    <div
                      class="table_screen_item"
                      style="
                        position: absolute;
                        left: 20px;
                        top: 0px;
                        z-index: 99999;
                      "
                    >
                      <el-radio-group
                        v-model="tabTime"
                        style="margin-bottom: 10px"
                        size="mini"
                      >
                        <el-radio-button label="0">年</el-radio-button>
                        <el-radio-button label="1">月</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div
                      class="table_screen_item"
                      style="
                        position: absolute;
                        right: 40px;
                        top: 0px;
                        z-index: 99999;
                      "
                    >
                      <template>
                        <el-select
                          v-model="year"
                          placeholder="请选择"
                          size="mini"
                          style="width: 100px"
                        >
                          <el-option
                            v-for="item in yearData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </template>
                      <template v-if="tabTime == 1">
                        <el-select
                          v-model="month"
                          placeholder="请选择"
                          size="mini"
                          style="width: 100px"
                        >
                          <el-option
                            v-for="item in monthData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </template>
                    </div>
                    <div class="canvanbox" id="IncomeEchart"></div>
                  </div>
                </el-col>
                <el-col :md="24" :lg="8" :xl="8">
                  <div class="table_screen_box">
                    <div class="table_screen_item">
                      <el-radio-group
                        v-model="tabCarousel"
                        style="margin-bottom: 10px"
                        size="mini"
                      >
                        <el-radio-button label="0">营业额</el-radio-button>
                        <el-radio-button label="1">充电量</el-radio-button>
                        <el-radio-button label="2">订单量</el-radio-button>
                        <el-radio-button label="3">利用率</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="ranking_box">
                    <div class="block">
                      <h3>
                        {{ order.currentMonthOrder.month }}月场站{{
                          tabCarousel | tabCarouselFilters
                        }}
                      </h3>
                      <el-carousel
                        trigger="click"
                        height="300px"
                        arrow="never"
                        :interval="10000"
                        @change="carouselChange"
                        ref="carousel"
                      >
                        <el-carousel-item
                          v-for="(
                            item, i
                          ) in stationRanking.stationCurrentMonthRanking"
                          :key="i"
                        >
                          <div class="ranking_table_box">
                            <template v-for="(v, index) in item">
                              <div class="ranking_table_item" :key="index">
                                <div>
                                  <span
                                    class="num"
                                    :class="index <= 2 ? 'ranking' : ''"
                                    >{{ index + 1 }}</span
                                  >
                                  <span class="station_name">{{ v.name }}</span>
                                </div>
                                <div>
                                  <span class="value_">{{ v.value }}</span>
                                </div>
                              </div>
                            </template>
                          </div>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="14">
              <el-col :md="24" :lg="12" :xl="12">
                <div class="overview_height">
                  <div class="cavasbox" id="RingDiagram"></div>
                </div>
              </el-col>
              <el-col :md="24" :lg="12" :xl="12">
                <div class="overview_height">
                  <!--设备实时状态-->
                  <div>
                    <!--自营场站概览-->
                    <div>
                      <el-row>
                        <div class="div_two">
                          <h5 class="h5_style">自营场站概览</h5>
                          <el-row>
                            <el-col :span="6" class="el_col_one"
                              >电站总数量</el-col
                            >
                            <el-col :span="6" class="el_col_one"
                              >电桩总数量</el-col
                            >
                            <el-col :span="6" class="el_col_one"
                              >电枪总数量</el-col
                            >
                            <el-col :span="6" class="el_col_one"
                              >总功率(kW)</el-col
                            >
                          </el-row>
                          <el-row>
                            <el-col :span="6" class="el_col_three"
                              >{{ selfStationStatistics.stationNum }}
                            </el-col>
                            <el-col :span="6" class="el_col_three"
                              >{{ selfStationStatistics.pileNum }}
                            </el-col>
                            <el-col :span="6" class="el_col_three"
                              >{{ selfStationStatistics.gunNum }}
                            </el-col>
                            <el-col :span="6" class="el_col_three"
                              >{{ selfStationStatistics.totalPower }}
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="6" class="el_col_four"
                              >{{ order.currentMonthOrder.month }}月新增<span
                                class="span_margin"
                                >{{ res.opertorRes.increStationNum }}</span
                              ></el-col
                            >
                            <el-col :span="6" class="el_col_four"
                              >{{ order.currentMonthOrder.month }}月新增<span
                                class="span_margin"
                                >{{ res.opertorRes.increPileNum }}</span
                              ></el-col
                            >
                            <el-col :span="6" class="el_col_four"
                              >{{ order.currentMonthOrder.month }}月新增<span
                                class="span_margin"
                                >{{ res.opertorRes.increGunNum }}</span
                              ></el-col
                            >
                            <el-col :span="6" class="el_col_four"
                              >{{ order.currentMonthOrder.month }}月新增<span
                                class="span_margin"
                                >{{ res.opertorRes.increPower }}kw</span
                              ></el-col
                            >
                          </el-row>
                        </div>
                      </el-row>
                    </div>
                  </div>
                  <el-row>
                    <div class="div_two">
                      <h5 class="h5_style">设备实时状态</h5>
                      <el-row>
                        <el-col :span="6" class="el_col_one"
                          ><span style="color: #409eff" class="span_one">●</span
                          >充电中枪口
                        </el-col>
                        <el-col :span="6" class="el_col_one"
                          ><span style="color: #43c26e" class="span_one">●</span
                          >空闲枪口
                        </el-col>
                        <el-col :span="6" class="el_col_one"
                          ><span style="color: #bdc1c2" class="span_one">●</span
                          >离线枪口
                        </el-col>
                        <el-col :span="6" class="el_col_one"
                          ><span style="color: #ffbc2e" class="span_one">●</span
                          >故障枪口
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6" class="el_col_two">
                          <div class="circleBox">
                            <el-progress
                              type="circle"
                              :show-text="false"
                              :width="100"
                              :stroke-width="10"
                              :percentage="
                                (gunRealTimeStatistics.chargingGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                100
                              "
                              v-if="
                                (gunRealTimeStatistics.chargingGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ||
                                (gunRealTimeStatistics.offlineGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ==
                                  0
                              "
                              color="#409eff"
                            ></el-progress>
                            <div class="circleCenter">
                              <div>
                                {{ gunRealTimeStatistics.chargingGunNum }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="6" class="el_col_two">
                          <div class="circleBox">
                            <el-progress
                              type="circle"
                              :show-text="false"
                              :width="100"
                              :stroke-width="10"
                              :percentage="
                                (gunRealTimeStatistics.freeGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                100
                              "
                              v-if="
                                (gunRealTimeStatistics.freeGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ||
                                (gunRealTimeStatistics.offlineGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ==
                                  0
                              "
                              color="#43c26e"
                            ></el-progress>
                            <div class="circleCenter">
                              <div>{{ gunRealTimeStatistics.freeGunNum }}</div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="6" class="el_col_two">
                          <div class="circleBox">
                            <el-progress
                              type="circle"
                              :show-text="false"
                              :width="100"
                              :stroke-width="10"
                              :percentage="
                                (gunRealTimeStatistics.offlineGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                100
                              "
                              v-if="
                                (gunRealTimeStatistics.offlineGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ||
                                (gunRealTimeStatistics.offlineGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ==
                                  0
                              "
                              color="#bdc1c2"
                            ></el-progress>
                            <div class="circleCenter">
                              <div>
                                {{ gunRealTimeStatistics.offlineGunNum }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="6" class="el_col_two">
                          <div class="circleBox">
                            <el-progress
                              type="circle"
                              :show-text="false"
                              :width="100"
                              :stroke-width="10"
                              :percentage="
                                (gunRealTimeStatistics.badGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                100
                              "
                              v-if="
                                (gunRealTimeStatistics.badGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ||
                                (gunRealTimeStatistics.offlineGunNum /
                                  gunRealTimeStatistics.totalGunNum) *
                                  100 ==
                                  0
                              "
                              color="#ffbc2e"
                            ></el-progress>
                            <div class="circleCenter">
                              <div>{{ gunRealTimeStatistics.badGunNum }}</div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-row>
                </div>
              </el-col>
              <!-- 个人和集团会员概览 -->
            </el-row>
            <!--互联互通场站-->
          </el-col>
          <el-col :span="24">
            <!-- 接口数据还没完善 -->
            <!-- <div class="overview_table">
              <h5 class="h5_style">互联互通场站</h5>
              <template>
                <el-table :data="InterconnectionData" style="width: 100%">
                  <el-table-column prop="totalFeen" label="全年充电收入">
                  </el-table-column>
                  <el-table-column
                    prop="monthFeen"
                    :label="currentMonth + '月充电收入'"
                  >
                  </el-table-column>
                  <el-table-column prop="yesterdayFee" label="昨日充电收入">
                  </el-table-column>
                  <el-table-column prop="totalFeenKwh" label="全年充电量(kW-h)">
                  </el-table-column>
                  <el-table-column
                    prop="monthFeenKwh"
                    :label="currentMonth + '月充电量(kW-h)'"
                  >
                  </el-table-column>
                  <el-table-column prop="yesterdayFeeKwh" label="昨日充电量(kW-h)">
                  </el-table-column>
                </el-table>
              </template>
            </div> -->
            <div class="overview_table">
              <h5 class="h5_style">会员概览</h5>
              <template>
                <el-table :data="groupData" style="width: 100%">
                  <el-table-column prop="name" label="会员类型">
                  </el-table-column>
                  <el-table-column prop="customerNum" label="数量">
                  </el-table-column>
                  <el-table-column prop="totalFee" label="总营业额">
                  </el-table-column>
                  <el-table-column
                    prop="totalElectricity"
                    label="总充电量(kW-h)"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="newCustomerNum"
                    :label="currentMonth + '月新增(人)'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="chargeCustomerNum"
                    label="充电人数(人)"
                  >
                  </el-table-column>
                  <el-table-column prop="orderNum" label="总充电次数(元)">
                  </el-table-column>
                  <el-table-column prop="serviceFee" label="总服务费(元)">
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
import Chart from "echarts";
import operatingViewOperatorApi from "../../monitoringCenter/api/operatingViewOperatorApi";
import { second2Time } from "@/common/validUtil.js";
import commonApi from "@/common/api/commonFromVuexApi.js";
import comApi from "@/common/api/commonApi.js";

export default {
  name: "OperatingViewOperator",
  data() {
    return {
      tabAnnual: "income", //全年切换
      tabRange: true, //年月切换
      tabCarousel: 0, //轮播显示
      tabTime: 0, //年月
      monthData: [], //月数据
      month: "",
      yearData: [], //年数据
      year: "",
      average: {
        income: 0,
        electric: 0,
        incomeYear: 0,
        electricYear: 0,
      }, //平均
      incomeChart: null,
      electricChart: null,
      RingDiagram: null,
      IncomeEchart: null,
      InterconnectionData: [], //互联互通
      groupData: [], //集团
      // //////////
      placeholder: "请选中运营商",
      operatorsTree: [], //运营商
      operatorIds: [],
      currentMonth: "",
      orderSourceMap: {},
      order: {
        currentDayCecOrder: {},
        currentDayOrder: {},
        currentMonthCecOrder: {},
        currentMonthOrder: {},
        currentYearCecOrder: {},
        currentYearOrder: {},
        dailyOrderList: {},
        monthlyOrderList: {},
        operatorStationDailyList: [],
        orderSource: {},
        totalOrder: {},
        utilization: 0,
        chargeLength: 0,
        yesterdayCecOrder: {},
        yesterdayOrder: {},
        accuracy: 0,
      },
      totalFee: 0,
      member: {},
      ops: {
        alarmTypes: {},
        alarmStatistic: {},
      },
      res: {
        gunHour: {},
        opertorRes: {},
        opertorCecRes: {},
      },
      gunRealTimeStatistics: {},
      selfStationStatistics: {},
      orderPart: {
        currentDayData: {},
        currentMonthData: {},
        currentYearData: {},
        groupMonthData: {},
        chargeLength: "0时0分0秒",
        usedRate: 0,
      },
      sixMonthData: [],
      stationRanking: {
        stationCurrentMonthTotal: {},
        stationCurrentMonthRanking: [],
      },
      customerNumber: {
        customerNum: 0,
        newCustomerNum: 0,
        groupNum: 0,
        groupCustomerNum: 0,
      },
      operatorAlarmRecord: {
        alarmLevelData: {},
        alarmTypeData: {},
        alarmType1: 0,
        alarmType2: 0,
        alarmType3: 0,
        alarmType4: 0,
      },
      selectForm: {},
      colorStyle: [
        {
          color: "#5cb87a",
          percentage: 80,
        },
        {
          color: "#e6a23c",
          percentage: 90,
        },
        {
          color: "#f56c6c",
          percentage: 100,
        },
      ],
      selectedOperatorId: "0",
      operators: {},
      operatorSelectInput: "",
      operatorName: " 全 部 ",
      operatorsTemp: "",
    };
  },
  // 导入组件
  components: {},
  // 创建完毕状态(里面是操作)
  created() {
    this.initCurrentMonth();
    var date = new Date();
    // this.month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    for (let index = 1; index <= 12; index++) {
      this.monthData.push({
        value: index,
        label: index + "月",
      });
    }

    this.year = date.getFullYear(); //获取完整的年份(4位)
    for (let y = 4; y >= 0; y--) {
      this.yearData.push({
        value: this.year - y,
        label: this.year - y + "年",
      });
    }
  },
  watch: {
    operatorSelectInput: function (val, oldVal) {
      if (val.length <= 0) {
        this.operatorsTemp = this.operators.slice(0, 10);
      } else {
        this.operatorsTemp = [];
        this.operators.forEach((item, index) => {
          if (item.name.indexOf(val) >= 0) {
            this.operatorsTemp.push(item);
          }
        });
      }
    },
    tabCarousel(tabCarousel) {
      this.$refs.carousel.setActiveItem(tabCarousel);
    },
    tabTime(tabTime) {
      if (tabTime == 0) {
        //年
        this.tabRange = true;
        this.month = "";
        this.getSixMonthChargeData();
      } else {
        this.tabRange = false;
        var date = new Date();
        this.month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        this.getSixMonthChargeData();
      }
    },
    month(month) {
      if (month) {
        this.getSixMonthChargeData();
      }
    },
    year(year) {
      if (year) {
        this.getSixMonthChargeData();
      }
    },
  },
  filters: {
    tabCarouselFilters(val) {
      if (val == 0) {
        return "营业额排行榜(元)";
      } else if (val == 1) {
        return "充电量排行榜(kW.h)";
      } else if (val == 2) {
        return "订单量排行榜(单)";
      } else if (val == 3) {
        return "利用率排行榜(%)";
      }
    },
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getRingStatistics();
    this.loadOperators();
    this.getOperatorsTree();
    this.getSixMonthChargeData();
    // ///////////////////////////////////////////////////
  },
  beforeUpdate: function () {
    this.getRing();
    // this.getIncome();
    /////////////////////////////////////
    // this.rankingList();
    // 4. 让图表跟随屏幕自动的去适应
    window.onresize = () => {
      return (() => {
        this.incomeChart.resize();
        this.electricChart.resize();
        this.RingDiagram.resize();
        this.IncomeEchart.resize();
      })();
    };
    this.groupData = [
      {
        name: "个人会员",
        customerNum: this.customerNumber.customerNum + "人",
        totalFee: this.orderPart.currentMonthData.totalFee,
        totalElectricity: this.orderPart.currentMonthData.totalElectricity,
        newCustomerNum: this.customerNumber.newCustomerNum,
        chargeCustomerNum: this.order.currentMonthOrder.chargeCustomerNum,
        orderNum: this.orderPart.currentMonthData.orderNum,
        serviceFee: this.orderPart.currentMonthData.serviceFee,
      },
      {
        name: "集团会员",
        customerNum: this.customerNumber.groupNum + "个集团",
        totalFee: this.orderPart.groupMonthData.totalFee,
        totalElectricity: this.orderPart.groupMonthData.totalElectricQuantity,
        newCustomerNum: this.customerNumber.groupCustomerNum,
        chargeCustomerNum: this.order.currentMonthOrder.chargeGroupNum,
        orderNum: this.orderPart.groupMonthData.totalOrderNumber,
        serviceFee: this.orderPart.groupMonthData.totalServiceFee,
      },
    ];
  },
  methods: {
    getSixMonthChargeData() {
      let month =
        this.month == ""
          ? this.month
          : this.month < 10
          ? "0" + this.month
          : this.month;
      let data = {
        operatorId:
          this.selectedOperatorId == "0" ? "" : this.selectedOperatorId,
        beginTime: this.year + String(month),
      };
      // 充电量营业额柱图
      operatingViewOperatorApi.getSixMonthChargeData(data).then((res) => {
        if (res.code === 0) {
          // this.sixMonthData = res.data;
          this.sixMonthData = res.data;
          this.getIncome();
        }
      });
    },
    tapPage(url) {
      this.$router.push(url);
    },
    // 幻灯片
    carouselChange(v, bool) {
      this.tabCarousel = v;
    },
    // 头部收入电量
    weekIncome: function () {
      this.incomeChart = Chart.init(document.getElementById("income"));
      this.electricChart = Chart.init(document.getElementById("electric"));
      let xdata = [];
      let ydataFee = [];
      let ydataElectricity = [];
      let incomeTotal = 0;
      let electricTotal = 0;
      for (let i = 0; i < this.order.dailyOrderList.length; i++) {
        xdata[i] = this.order.dailyOrderList[i].batchTime;
        ydataFee[i] = this.order.dailyOrderList[i].totalFee;
        ydataElectricity[i] =
          this.order.dailyOrderList[i].totalElectricQuantity;
        incomeTotal += this.order.dailyOrderList[i].totalFee;
        electricTotal += this.order.dailyOrderList[i].totalElectricQuantity;
      }
      this.average.income = (
        incomeTotal / this.order.dailyOrderList.length
      ).toFixed(2);
      this.average.electric = (
        electricTotal / this.order.dailyOrderList.length
      ).toFixed(2);
      this.incomeChart.clear();
      this.electricChart.clear();
      this.incomeChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "0%",
          width: "100%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xdata,
          show: false,
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "当日收入(元)",
            type: "line",
            stack: "收入",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(1, 191, 236)",
                },
                {
                  offset: 1,
                  color: "rgba(1, 191, 236)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: ydataFee,
          },
        ],
      });
      this.electricChart.setOption({
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "0%",
          width: "100%",
        },
        xAxis: {
          type: "category",
          data: xdata,
          show: false,
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "当日充电量(kW·h)",
            type: "bar",
            stack: "充电量",
            smooth: true,
            color: "rgba(1, 191, 236)",
            // barWidth: 8, //柱图宽度
            data: ydataElectricity,
          },
        ],
      });
    },

    // 环形图-- 6月充电订单来源
    getRing() {
      this.RingDiagram = Chart.init(document.getElementById("RingDiagram"));
      let colorData = [
        "#ff7070",
        "#7ed3f4",
        "#5470c6",
        "#3aa1ff",
        "#ff7d57",
        "#ffdc60",
        "#9fe080",
        "#c0c4cc",
      ];
      let myMap = {};
      for (let i = 0; i < this.order.orderSource.length; i++) {
        if (myMap.hasOwnProperty(this.order.orderSource[i].orderSource)) {
          myMap[this.order.orderSource[i].orderSource] =
            myMap[this.order.orderSource[i].orderSource] +
            this.order.orderSource[i].orderNum;
        } else {
          myMap[this.order.orderSource[i].orderSource] =
            this.order.orderSource[i].orderNum;
        }
      }
      this.orderSourceMap = myMap;
      let data = [0];
      let mapIndex = 0;
      for (let key in myMap) {
        data[mapIndex] = {
          value: myMap[key],
          name: key,
          itemStyle: { color: colorData[mapIndex] },
        };
        mapIndex = mapIndex + 1;
      }
      this.RingDiagram.setOption({
        title: {
          text: this.order.currentMonthOrder.month + "充电订单来源",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          formatter: function (data) {
            return `<div style="text-align:left;">
            <div>${data["name"]}</div>
            <div>订单量 :${data["value"]}</div>
            <div>占比 :${data["percent"]}%</div>
            </div>`;
          },
        },
        legend: {
          // orient: "vertical",
          right: "right",
          bottom: "bottom",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["30%", "60%"],
            // center: ['center', '60%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    // 收入分布
    getIncome() {
      let xData = []; //时间
      let totalFee = []; //总营业额
      let totalElec = []; //总充电量
      let totalOrder = [];
      // let groupFee = []; //集团营业额
      // let groupElec = []; //集团电量
      this.IncomeEchart = Chart.init(document.getElementById("IncomeEchart"));
      for (let i = 0; i < this.sixMonthData.length; i++) {
        let arr = this.sixMonthData[i].batchTime.split("-");
        xData[i] =
          arr.length == 2 ? arr[arr.length - 1] + "月" : arr[arr.length - 1];
        totalFee[i] = this.sixMonthData[i].stationFee;
        totalElec[i] = this.sixMonthData[i].stationElectricQuantity;
        totalOrder[i] = this.sixMonthData[i].groupOrderNumber;
        // groupFee[i] = this.sixMonthData[i].groupFee;
        // groupElec[i] = this.sixMonthData[i].groupElectricQuantity;
      }

      this.IncomeEchart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ["总营业额", "总充电量", "订单量"],
          // left: "3%",
          bottom: "bottom",
          center: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },

        xAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#90979c",
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            data: xData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "总营业额",
            type: "bar",
            stack: "总营业额",
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: "#ff608d"
              // color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
              //   { offset: 0, color: "#ff7d56" },
              //   { offset: 0.5, color: "#ff608d" },
              //   { offset: 1, color: "#ff608d" },
              // ]),
            },
            data: totalFee,
          },
          {
            name: "总充电量",
            type: "bar",
            stack: "总充电量",
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: "#5aafff"
              // color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
              //   { offset: 0, color: "#5aafff" },
              //   { offset: 0.5, color: "#5175fe" },
              //   { offset: 1, color: "#5175fe" },
              // ]),
            },
            data: totalElec,
          },
          {
            name: "订单量",
            type: "bar",
            stack: "订单量",
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: "#eb70e9 "
              // color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
              //   { offset: 0, color: "#eb70e9 " },
              //   { offset: 0.5, color: "#8c64f7" },
              //   { offset: 1, color: "#8c64f7" },
              // ]),
            },
            data: totalOrder,
          },
        ],
      });
    },
    // 、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、、
    setTreeDisable(val) {
      //对 treeList 进行递归操作，禁止选中unchecked和unapproved
      val &&
        val.forEach((item) => {
          if (
            item.checked &&
            (item.checked === "unchecked" || item.checked === "unapproved")
          ) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
      return val;
    },
    //获取运营商树
    getOperatorsTree() {
      let params = JSON.stringify({});
      comApi.getOperatorsTree(params).then((res) => {
        this.operatorsTree = this.setTreeDisable(res.data);
        // 显示当前登录运营商
        if (res.data.length == 1) {
          this.placeholder = res.data[0].label;
        }
      });
    },
    handChangeOperator(val) {
      let selectedOperatorId =
        val && val.length > 0 ? val[val.length - 1] : "0";
      this.selectedOperatorId = selectedOperatorId;
      this.getRingStatistics();
       this.getSixMonthChargeData();
      this.$refs.cascader.dropDownVisible = false;
    },
    initCurrentMonth() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      this.currentMonth = yy + "-" + mm;
    },
    //加载运营商列表
    loadOperators() {
      commonApi.getOperators().then((res) => {
        this.operators = res;
        this.operatorsTemp = res.slice(0, 10);
      });
    },
    selectOperator(command, event) {
      this.operatorName = event.$el.innerText;
      this.selectedOperatorId = command.substr(0, 18);
      this.getRingStatistics();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "";
    },
    async getRingStatistics() {
      // let operatorId = this.$store.getters.operatorIds[0]
      let operatorId = this.selectedOperatorId;
      operatingViewOperatorApi.getRingStatistics(operatorId).then((res) => {
        if (res) {
          this.order = res.operatorOrder;
          this.member = res.operatorMember;
          this.ops = res.operatorOps;
          this.res = res.operatorRes;
          this.InterconnectionData = [
            {
              totalFee: res.operatorOrder.currentYearCecOrder.totalFee,
              monthFee: res.operatorOrder.currentMonthCecOrder.totalFee,
              yesterdayFee: res.operatorOrder.yesterdayCecOrder.totalFee,
              totalfeeKwh: res.operatorOrder.currentYearCecOrder.totalFee,
              monthFeekwh: res.operatorOrder.currentMonthCecOrder.totalFee,
              yesterdayFeekwh: res.operatorOrder.yesterdayCecOrder.totalFee,
            },
          ];
          this.weekIncome();
        } else {
        }
      });
      /*充电站部分*/
      if (operatorId === "0") operatorId = "";
      this.selectForm.operatorId = operatorId;
      let param = JSON.stringify(this.selectForm);
      await operatingViewOperatorApi
        .getGunRealTimeStatistics(param)
        .then((res) => {
          if (res) {
            this.gunRealTimeStatistics = res.gunRealTimeStatistics;
            this.selfStationStatistics = res.selfStationStatistics;
          }
        });
      /*订单收入部分*/
      operatingViewOperatorApi.getOrderStatisticsV2(param).then((res) => {
        if (res) {
          this.orderPart.currentDayData = res.currentDayData; //当前日数据
          this.orderPart.currentMonthData = res.currentMonthData; //当前月数据
          this.orderPart.currentYearData = res.currentYearData; //当前年份数据
          this.orderPart.groupMonthData = res.groupMonthData; //每月
          this.orderPart.chargeLength = second2Time(
            res.currentDayData.chargeLength
          );
          console.info(
            "chargeLength:" +
              res.currentDayData.chargeLength +
              "chargingGunNum:" +
              this.gunRealTimeStatistics.chargingGunNum +
              ",freeGunNum:" +
              this.gunRealTimeStatistics.freeGunNum
          );
          this.orderPart.usedRate =
            Math.round(
              (res.currentDayData.chargeLength /
                (86400 *
                  (this.gunRealTimeStatistics.chargingGunNum +
                    this.gunRealTimeStatistics.freeGunNum))) *
                10000
            ) / 100.0;
        }
      });
      /*充电概览及排行前10*/
      operatingViewOperatorApi.getOperatorStationRanking(param).then((res) => {
        if (res.code === 0) {
          // 充电概览
          this.stationRanking.stationCurrentMonthTotal =
            res.data.stationCurrentMonthTotal;
          // 排行数据
          let listData = res.data.stationCurrentMonthRanking;
          let data1 = []; //营业额
          let data2 = []; //充电量
          let data3 = []; //订单量
          let data4 = []; //利用率
          listData.forEach((item, i) => {
            data1[i] = {
              name: item.stationName,
              value: item.totalFee,
            };
            data2[i] = {
              name: item.stationName,
              value: item.totalElectricQuantity,
            };
            data3[i] = {
              name: item.stationName,
              value: item.totalOrderNumber,
            };
            data4[i] = {
              name: item.stationName,
              value: item.usedRate,
            };
          });
          var compare = function (obj1, obj2) {
            var val1 = obj1.value;
            var val2 = obj2.value;
            if (val1 > val2) {
              return -1;
            } else if (val1 < val2) {
              return 1;
            } else {
              return 0;
            }
          };
          data1 = data1.sort(compare);
          data2 = data2.sort(compare);
          data3 = data3.sort(compare);
          data4 = data4.sort(compare);
          this.stationRanking.stationCurrentMonthRanking = [
            data1,
            data2,
            data3,
            data4,
          ];
        } else {
          console.log("充电概览及排行榜，数据获取异常");
        }
      });

      /*当月故障总览*/
      operatingViewOperatorApi.getOperatorAlarm(param).then((res) => {
        if (res.code === 0) {
          this.operatorAlarmRecord.alarmLevelData = res.data.alarmLevelData;
          this.operatorAlarmRecord.alarmTypeData = res.data.alarmTypeData;
          if (res.data.alarmTypeData.length > 0) {
            for (let i = 0; i < res.data.alarmTypeData.length; i++) {
              let s = res.data.alarmTypeData[i];
              if (s.alarmType === "exce_end") {
                this.operatorAlarmRecord.alarmType1 = s.alarmTypeNumber;
              } else if (s.alarmType === "start_fail") {
                this.operatorAlarmRecord.alarmType2 = s.alarmTypeNumber;
              } else if (s.alarmType === "system_error") {
                this.operatorAlarmRecord.alarmType3 = s.alarmTypeNumber;
              } else if (s.alarmType === "alarm") {
                this.operatorAlarmRecord.alarmType4 = s.alarmTypeNumber;
              }
            }
          } else {
            this.operatorAlarmRecord.alarmType1 = 0;
            this.operatorAlarmRecord.alarmType2 = 0;
            this.operatorAlarmRecord.alarmType3 = 0;
            this.operatorAlarmRecord.alarmType4 = 0;
          }
        } else {
          console.log("充电告警概览，数据获取异常");
        }
      });
      // 个人会员
      operatingViewOperatorApi.getCustomerStatisticsData(param).then((res) => {
        if (res.code === 0) {
          this.customerNumber.customerNum = res.data.customerNum;
          this.customerNumber.newCustomerNum = res.data.newCustomerNum;
          this.customerNumber.groupNum = res.data.groupNum;
          this.customerNumber.groupCustomerNum = res.data.groupCustomerNum;
        }
      });
      // // 充电量营业额柱图
      // operatingViewOperatorApi.getSixMonthChargeData(param).then((res) => {
      //   if (res.code === 0) {
      //     // this.sixMonthData = res.data;
      //     console.log(res.data);
      //   }
      // });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff;
  border-color: #009688;
  color: #009688;
}

.top_gtitle_box {
  border-radius: 4px;
  background: #fff;
  margin-bottom: 15px;
  text-align: left;
  padding: 20px;

  .top_box {
    height: 120px;

    .gun_info_box {
      display: flex;
      justify-content: space-between;

      .fault {
        font-size: 12px !important;
        display: flex;
        line-height: 20px;
        color: #707070;
        cursor: pointer;

        .el-icon-warning {
          font-size: 40px;
          color: #ff8f33;
          margin-right: 5px;
        }

        .el-icon-arrow-right {
          font-weight: bold;
          vertical-align: middle;
          color: #333333;
          margin-left: 5px;
        }
      }
    }

    .top_title {
      font-size: 14px;
      color: #8c8c8c;

      .tab_icon {
        display: flex;
        justify-content: space-between;

        .tooltipClick {
          cursor: pointer;
        }
      }

      .income,
      .electric {
        font-size: 26px;
        color: #595959;
        padding-top: 5px;
      }
    }
    #income,
    #electric {
      width: 100%;
      height: 60px;
    }
  }

  .average_box {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #d9d9d9;
    padding-top: 5px;
    color: #595959;
    font-size: 13px;
  }
}

.table_box {
  width: 100%;
  padding: 20px 20px 0;
  box-sizing: border-box;
  background-color: #fff;
  margin-bottom: 14px;

  .table_screen_box {
    width: 100%;
    border-bottom: 1px solid #f2f2f2;

    .table_screen_item {
      line-height: 28px;
      display: inline-block;

      // div {
      //   color: #009688;
      //   font-size: 14px;
      //   cursor: pointer;
      //   margin-right: 10px;
      // }
    }
  }

  .ranking_box {
    width: 100%;
    padding-bottom: 20px;
    text-align: left;

    h3 {
      color: #2b2b2b;
      font-size: 14px;
      font-weight: 400;
      padding-top: 14px;
    }
    .ranking_table_item {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 35px;
      color: #87888a;

      .num {
        background-color: #f0f2f5;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        text-align: center;
        width: 20px;
        border-radius: 50%;
        font-size: 12px;
        margin-right: 15px;
      }

      .num.ranking {
        background-color: #009688;
        color: #fff;
      }
    }

    .ranking_pagination_box {
      text-align: center;
      margin-top: 10px;
    }
  }
}

.canvanbox {
  box-sizing: border-box;
  width: 100%;
  height: 400px;
  min-width: 500px;
}

.overview_height {
  height: 360px;
  padding: 20px;
  background-color: #fff;

  .circleBox {
    position: relative;
    text-align: center;

    .circleCenter {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
    }
  }
}

.st-gbox {
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
}

.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.overview_table {
  margin-top: 14px;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;

  /deep/.el-table th {
    background: #f5f5f5;
  }
}
/////////////////////////////////////////////////////

.fontcCloor {
  color: white;
  font-size: 26px;
  text-align: left;
  margin: 5px 0px 25px 20px;
}

.fontSize {
  color: white;
  font-size: 12px;
  text-align: left;
  margin: 20px 0px 0px 20px;
}

.fontStyle_one {
  color: white;
  font-size: small;
}

.fontStyle_four {
  font-size: small;
}

.fontStyle_five {
  font-size: 20px;
  margin-top: 5px;
}

.fontStyle_two {
  color: white;
  font-size: 20px;
  margin-top: 5px;
}

.fontStyle_three {
  margin: 10px 20px 0px 20px;
}

.div_style {
  float: left;
  width: 31%;
  height: 100px;
  margin: 0px 10px 10px 0px;
}

.div_style > div {
  height: 100%;
  position: relative;
  z-index: 99;
  padding-left: 40px;
  box-sizing: border-box;
  overflow: hidden;
}

.iconfont1 {
  position: absolute;
  top: 0;
  left: 0;
}

.left_icon {
  left: 20px;
  top: 20px;
  font-size: 25px;
  color: #ffffff;
}

.right_icon {
  right: -180px;
  top: 20px;
  font-size: 120px;
  color: rgba(255, 255, 255, 0.2);
}

.div_margin {
  padding-bottom: 10px;
  position: relative;
}

.div_bule {
  /* background-color: #409eff; */
  background-image: linear-gradient(to right, #ff7d54, #fe5f8d);
}

.div_green {
  background-image: linear-gradient(to right, #5ab0ff, #5173fe);
  /* background-color: #43c26e; */
}

.div_Orange {
  background-image: linear-gradient(to right, #ff7d54, #fe5f8d);
  /* background-color: #ffbc2e; */
}

.div_red {
  /* background-color: #ff6640; */
  background-image: linear-gradient(to right, #5ab0ff, #5173fe);
}

.div_purple {
  /* background-color: #c640ff; */
  background-image: linear-gradient(to right, #22cab7, #179ecf);
}

.div_skyblue {
  /* background-color: #36f3ff; */
  background-image: linear-gradient(to right, #22cab7, #179ecf);
}

.span_green {
  color: #43c26e;
  font-weight: bold;
}

.span_red {
  color: #c22d1b;
  font-weight: bold;
}

.span_margin {
  margin-left: 15px;
}

.div_style_one {
  float: left;
  width: 31%;
  height: 60px;
  margin: 0px 10px 10px 0px;
}

.st-gbox_one {
  margin-left: 20px;
  height: 400px;
}

.st-gbox_two {
  height: 340px;
}

.div_one {
  background-color: #f2f6fc;
}

.div_two {
  background-color: white;
}

.div_three {
  background-color: #ebeef5;
  padding: 5px 0px 0px 10px;
  font-size: small;
}

.el_col_one {
  color: #b6b6c2;
  font-size: small;
}

.el_col_two {
  font-size: 30px;
  margin: 15px 0px 15px 0px;
}

.el_col_three {
  font-size: 30px;
  margin: 15px 0px 10px 0px;
}

.el_col_exit {
  font-size: 16px;
  margin: 15px 0px 10px 0px;
}

.el_col_four {
  color: #606266;
  font-size: small;
  margin-bottom: 15px;
}

.span_one {
  margin-right: 5px;
  font-size: 20px;
}

.h5_style {
  text-align: left;
  margin: 0px 0px 20px 18px;
  // padding-top: 20px;
}

/deep/ .el-table .warning-row {
  background: oldlace;
}

/deep/ .el-table .success-row {
  background: #f0f9eb;
}

// /deep/ .el-input__inner {
.agent_screen /deep/ .el-input__inner {
  background-color: #364150;
  border-radius: 15px;
  border-color: #f1f4f6;
  color: #ffffff;
  font-size: large;
  font-weight: bold;
}

.el-header {
  height: 60px !important;
  line-height: 60px;
  padding: 0 10px;
}

/* 充电排行 */
.wrapper .paihangbang3_box {
  /* background: url("../../../static/img/bg.png") no-repeat center/100%
    100%; */
  padding-top: 20px;
  transform: translateY(-12px);
}
</style>



// WEBPACK FOOTER //
// src/module/monitoringCenter/page/operatingView_operator.vue